import vod from "../pages/vod/routes";
import search from "../pages/search/routes";


export default [...vod, ...search];